import React from "react";
import "./style.css";

export default function Booking(props) {
    return (
        <div className={`page bookingPage transition ${props.className}`}>
                <iframe src="https://eskew-consulting.bookafy.com/schedule?type=iframe&locale=en" height="100%" width="100%" frameBorder="0" title="booking page"> </iframe>
        </div>
    )
}